import {buildColumn, XLARGE_CELL_WIDTH} from '@eitje/web_components'
import {ArrayCell} from '~/components/advanced_table/components/cells/array_cell'
import {FirmNameCell} from '~/components/advanced_table/components/cells/firm_name_cell'
import {FirmStatusCell} from '~/components/advanced_table/components/cells/firm_status_cell'
import {TranslationCell} from '~/components/advanced_table/components/cells/translation_cell'
import {getFirmStatus} from '~/helpers'
import {formatDate} from '@eitje/web_components'

export const columns = [
	{
		id: 'name',
		accessorFn: firm => firm.company_name || firm.name || firm.naam,
		width: XLARGE_CELL_WIDTH,
		cell: FirmNameCell,
		aggregates: false,
	},
	{
		id: 'firm_type',
		accessorFn: firm => `records.default.fields.firm_types.${firm.tableName}`,
		cell: TranslationCell,
		aggregates: false,
	},
	{
		id: 'status',
		accessorFn: firm => firm.status || getFirmStatus(firm.environments),
		cell: FirmStatusCell,
		aggregates: false,
	},
	{
		id: 'organisation',
		accessorFn: firm => firm.organisation?.name,
		aggregates: false,
	},
	{
		id: 'environments',
		accessorFn: firm => firm.environments?._map('naam'),
		cell: ArrayCell,
		aggregates: false,
	},
	{
		id: 'billing_infos',
		accessorFn: firm => {
			let infos = []
			if (firm.billingInfos) infos = firm.billingInfos
			if (firm.billingInfo) infos = [firm.billingInfo]
			return infos._map('company_name')
		},
		cell: ArrayCell,
		aggregates: false,
	},
	{
		accessorKey: 'id',
	},
	{
		accessorKey: 'created_at',
		format: formatDate,
		aggregates: false,
	},
].map(buildColumn)
